module.exports = __webpack_public_path__ + "media/bannerBack.0e680fdf.mp4";